import { Link, useLocation } from 'react-router-dom';
import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import classNames from 'classnames';
import { selectOverlay } from 'ducks/overlays/selectors';
import { Icon } from 'framework/Icon';
import { Tooltip } from 'framework/Tooltip';
import { useAppSelector } from 'store/hooks';

import cn from './Drawer.module.scss';

export const DrawerLink = ({
  to,
  information,
  icon,
}: {
  to: string;
  information: string;
  icon: IconDefinition;
}) => {
  const { is_open } = useAppSelector(selectOverlay('drawer'));
  const { pathname } = useLocation();
  return (
    <Tooltip information={is_open ? '' : information}>
      <Link
        to={to}
        className={classNames(cn.action, 'transition', {
          [cn.active]: pathname.includes(to),
        })}
      >
        <Icon size="14px" width="50px" icon={icon} />
        <p>{information}</p>
      </Link>
    </Tooltip>
  );
};
